import { Component } from '@angular/core';
import { ModalService } from '@avla/ui-design';
import { TokenService } from '@services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  environment = environment;

  year: Number = new Date().getFullYear();

  constructor(private modalService: ModalService) {}

  public get isLogged() {
    return TokenService.isLogged();
  }
  onHandleOpenTermsYCond() {
    this.modalService.open('modal-terms-conditions');
  }

  onHandleOpenPolPriv() {
    this.modalService.open('modal-policy-privacy');
  }
}
